import * as React from "react";
import { Button, styled } from "@mui/material";
import { PatientColorMap } from "../../../../../layout/patientColorMap";
import clsx from "clsx";
import { MeasurementUnitsToString } from "../../../../../utils/dataHelpers";
import { UnitConverter } from "../numericInput";
import { onRtl } from "fe-web-components/rtl/rtlStyles";

//region [[ Styles ]]

const UnitChangerViewView = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "0 7px",
  ...onRtl({
    flexDirection: "row-reverse",
  }),
});

const UnitIcon = styled(Button)({
  "&.unit-icon, &.unit-icon:hover, &.unit-icon:focus, &.unit-icon:active": {
    backgroundColor: PatientColorMap.White,
    color: PatientColorMap.Primary,
    borderRadius: "50%",
    minWidth: "fit-content",
    width: "30px",
    height: "30px",
    fontSize: "10px",
    padding: "3px",
    marginRight: "7px",
    // "&:first-of-type": {
    //   marginRight: "7px",
    // },
    border: `1px solid ${PatientColorMap.Primary}`,
    "&.selected": {
      backgroundColor: PatientColorMap.Primary,
      color: PatientColorMap.White,
    },
    textTransform: "none",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface UnitChangerViewProps {
  unitConverts?: UnitConverter[];
  currentUnitConverter?: UnitConverter;
  onUnitConverterSelected?: (UnitConverter) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const UnitChangerView = ({
  unitConverts,
  currentUnitConverter,
  onUnitConverterSelected,
  ...props
}: UnitChangerViewProps) => {
  if (!unitConverts) return null;
  return (
    <UnitChangerViewView>
      {unitConverts.map((unit) => (
        <UnitIcon
          className={clsx(
            "unit-icon",
            unit.unit === currentUnitConverter?.unit ? "selected" : "",
          )}
          onClick={() => onUnitConverterSelected(unit)}
          key={unit.unit}
        >
          {unit.displayText ||
            MeasurementUnitsToString(unit.unit, (i) => i, true)}
        </UnitIcon>
      ))}
    </UnitChangerViewView>
  );
};
